var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"height":"100%","width":"100%","src":"https://www.landinginternational.com/terms-of-use"}})
}
var staticRenderFns = []

export { render, staticRenderFns }